import { api } from '@/api'
import { OrganizationTypeRes } from '@/modules/organization/types/organizationType'

type ImageUploadResponce = {
  imageId: number
  imageUrl: string
  success: boolean
}

type Res = {
  data: OrganizationTypeRes[]
}

const uploadDocService = api.injectEndpoints({
  endpoints: (build) => ({
    uploadFeaturesDocs: build.mutation<ImageUploadResponce, FormData>({
      query: (body) => ({
        url: '/devices/addDeviceDocuments',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
    deleteFeaturesDoc: build.mutation<
      ImageUploadResponce,
      { deviceId: number; id: number }
    >({
      query: (body) => ({
        url: '/devices/deleteDeviceDocument',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Properties'],
    }),
  }),
})

export const { useUploadFeaturesDocsMutation, useDeleteFeaturesDocMutation } =
  uploadDocService
